<template>
  <el-dialog :visible.sync="AgreementBox" :before-close="handleClose" class="register-terms" :close-on-press-escape="false" :close-on-click-modal="false" ref="dialog" :show-close="false" width="850px" :append-to-body="true">
    <div class="popup_container w_popup_container">

      <div v-html="registerHtml"></div>
      <div class="online_rule_submit">
        <div class="online_rule_submit_button active dialog-btn-close" @click="handleClose">
          关闭
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AgreementBox: true,
      registerHtml: ''
    }
  },
  created() {
    if (!window.registerHtml) {
      const r = document.createElement('script');
      r.type = 'text/javascript';
      r.src = 'https://cnstatic.sgsonline.com.cn/tic/staticVariables/registerHtml.js';
      document.body.appendChild(r);
    }
  },
  mounted() {
    setTimeout(() => {
      this.registerHtml = window.registerHtml
    },50)
  },
  methods: {
    handleClose() {
      this.$emit('setTipsVisible', false)
    }
  }
}
</script>

<style lang="scss">
.register-terms {
  .w_popup_container {
    padding-top: 20px;
  }

  .popup_container {
    background: #fff;
    border-radius: 4px;
    border: 4px solid rgba(0, 0, 0, .2);
  }

  .popup_container {
    width: 850px;
    height: 600px;
  }

  .online_rule_title {
    text-align: center;
    margin-bottom: 20px;
  }

  .online_rule_title p {
    color: #333;
    font-size: 18px;
    margin-bottom: 10px;
    margin-top: 0;
    line-height: 1;
  }

  .online_rule_content {
    width: 800px;
    height: 466px;
    border-radius: 2px;
    background-color: #f8f8f8;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px;
    padding-right: 0px;
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    overflow: auto;
    text-align: left;
  }

  .popup_container .online_rule_content .title {
    clear: both;
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    padding-left: 32px;
    padding-top: 16px;
  }

  .online_rule_content ul li {
    clear: both;
    padding-top: 4px;
    line-height: 18px;
  }

  .online_rule_content ul li div.left {
    float: left;
    height: auto;
    width: 32px;
  }

  .online_rule_content ul li div.right {
    float: left;
    width: 720px;
  }

  .online_rule_submit {
    margin-top: 10px;
    text-align: center;
  }

  .online_rule_submit_button {
    display: inline-block;
    width: 195px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    color: #999;
    font-size: 16px;
    cursor: pointer;
  }

  .online_rule_submit_button.active {
    color: #fff;
    background: #ca4300;
  }
}
</style>
<style lang="scss">
  .register-terms {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
</style>
